import { createContext } from 'react';

const UserContext = createContext({
  isLogin: false,
  profile: {
    firstname: '',
  },
});

export default UserContext;
